import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ToTopOutlinedSvg from "@ant-design/icons-svg/es/asn/ToTopOutlined";
import AntdIcon from "../components/AntdIcon";
var ToTopOutlined = function ToTopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ToTopOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ToTopOutlined.displayName = 'ToTopOutlined';
}
export default /*#__PURE__*/React.forwardRef(ToTopOutlined);